/**Formulario de ingreso del codigo de seguridad*/
import React from 'react';
import { Button, Form, Modal, Container } from 'react-bootstrap';
import { connect } from 'react-redux';
import { signOut, popupBot, newUserDetails, newUsers } from '../../actions';
import history from '../../history';
import Alert from '../hupUtils/alert';
import { dataBaseManager } from '../hupUtils/utils';



class FomrularioGlobal extends React.Component {

    state = {
        validated: false,
        formError: null, errorCodigo: null,
        codigo: null, open: true,
        mensajeCodigo: { titulo: 'Falta campos por llenar', detalle: 'Debes diligenciar todos los campos' }
    }

    componentDatabase(tipo, path, objectIn, mensaje, mensajeError) {
        let men = dataBaseManager(tipo, path, objectIn, mensaje, mensajeError);
        if (men && men.mensaje)
            this.props.popupBot({ mensaje: men.mensaje });
        return men;
    }

    continuar = () => {


        const starCountRef = this.componentDatabase('get', `Codigo-Acceso/${this.props.newUserDetail ? this.props.newUserDetail.codigo : null}`);
        starCountRef.on('value', (snapshot) => {
            const cod = snapshot.val();
            if (cod) {
                if (cod.estado !== 'activo' && cod.usuarios < cod.equipo) {
                    //codigo usado
                    history.push('/formulario/termcond');
                    this.props.newUserDetails({ ...this.props.newUserDetail, rol: '3' })
                }
                else if (cod.estado !== 'activo' && cod.usuarios >= cod.equipo) {
                    //codigo usado
                    this.setState({ errorCodigo: true });
                    this.setState({ formError: true });
                    this.setState({ mensajeCodigo: { titulo: 'Codigo incorrecto', detalle: 'El codigo ya ha sido utilizado' } });
                }
                else {
                    history.push('/formulario/inicio');
                    this.props.newUserDetails({ ...this.props.newUserDetail, rol: '2' })
                }
            }
            else {
                //codigo que no existe
                this.setState({ errorCodigo: true });
                this.setState({ formError: true });
                this.setState({ mensajeCodigo: { titulo: 'Codigo incorrecto', detalle: 'No se tiene ninguna concidencia con el codigo escrito' } });
            }
        });
    }

    cancelar = () => {

        this.props.signOut();
        this.props.newUsers(false);
        this.props.signOutObj.signOut();
        this.cerraForm();
    }


    cerraForm = () => {
        this.timeout = setTimeout(() => {
            this.close();
            history.push('/');
        }, 200)
    }

    componentDidMount() {


        if (!this.props.userDetail) {
            history.push('/');
            return;
        }
    }
    close = () => this.setState({ open: false })

    handleSubmit(event) {
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.setState({ validated: true })
    }


    render() {

        return (

            <Modal show={true} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter"  >
                        Empecemos
                </Modal.Title>
                </Modal.Header>
                <Modal.Body className="show-grid">
                    <Container>
                        <Form noValidate validated={this.state.validated} onSubmit={(e) => this.handleSubmit(e)}>
                            <Form.Group controlId="ControlInput1">
                                <Form.Label>Intruduce tu codigo de acceso</Form.Label>
                                <Form.Control name="code"
                                    type="text" placeholder="HUPXSsd.." required value={this.props.newUserDetail ? this.props.newUserDetail.codigo : null}
                                    onChange={(e) => this.props.newUserDetails({ ...this.props.newUserDetail, codigo: e.target.value })} />
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>

                            </Form.Group>
                            <Alert error={this.state.formError} messageAlert={this.state.mensajeCodigo.detalle} headerAlert={this.state.mensajeCodigo.titulo} ></Alert>
                        </Form>

                    </Container>
                </Modal.Body>
                <Modal.Footer  >

                    <Button variant='light' onClick={() => this.cancelar()}>
                        Cancelar
                        </Button>
                    <Button variant="info" style={{ background: 'purple', borderRadius: '10px' }} onClick={(e) => { this.handleSubmit(e); this.continuar(); }}>
                        Continuemos  <i className="material-icons md-18">done_outline</i>
                    </Button>

                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        signOutObj: state.mainReducer.signOutObj,
        userDetail: state.mainReducer.userDetail,
        newUserDetail: state.mainReducer.newUserDetail,
    };
};

export default connect(mapStateToProps, { signOut, newUserDetails, newUsers, popupBot })(FomrularioGlobal);

